const index = () => import('./Index');

//2022年中小企业首次贷款利息补贴资金申请表
export default {
  routes: [
    {
      path: '/smes/loan/v2022/index',
      name: 'smes_loan_2022_index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/loan/v2022/router.js